import { observer } from 'mobx-react-lite'
import { OCRConfirmBulkSubmitDialog } from '@/features/jobs/scoping/components/OCRConfirmBulkSubmitDialog'
import { type OCRConfirmBulkSubmitDialogViewModel } from './OCRConfirmBulkSubmitDialogViewModel'

export interface OCRConfirmBulkSubmitDialogContainerProps {
  vm: OCRConfirmBulkSubmitDialogViewModel
}

export const OCRConfirmBulkSubmitDialogContainer = observer(
  function OCRConfirmBulkSubmitDialogContainer({
    vm,
  }: OCRConfirmBulkSubmitDialogContainerProps) {
    return (
      <OCRConfirmBulkSubmitDialog
        showing={vm.modal.showing}
        selectedCount={vm.selectedCount}
        onClose={vm.cancel}
        onConfirm={vm.confirm}
      />
    )
  },
)
